//JWT action
import { JwtActionTypes, SetJwt, ClearJwt } from 'Actions/ActionTypes/jwt';

export const setJwt = (jwt: string): SetJwt => ({
    type: JwtActionTypes.SetJwt as JwtActionTypes.SetJwt,
    jwt
});

export const clearJwt = (): ClearJwt => ({
    type: JwtActionTypes.ClearJwt as JwtActionTypes.ClearJwt
});

export type JwtAction = ReturnType<typeof setJwt | typeof clearJwt >